import Loadable from 'react-loadable';
import { useStore } from 'react-redux';
import { Store } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { withAsyncContainer } from '../common';

type StoreProps = Pick<Store, 'injectReducer' | 'dispatch' | 'getState'>;

const EmptyAsyncContainer = withAsyncContainer(() => null);

const StoreHOC = ({ children }: { children: (storeProps: StoreProps) => React.ReactNode }) => {
    const store = useStore<Store>() as unknown as Store;
    return <>{children(store)}</>;
};
/** @deprecated use @loadable/component */
export const LazyLoadable = <Props extends object, Exports extends object, ExtraProps extends object>({
    loader,
    render: renderFunction,
}: {
    loader: Loadable.OptionsWithMap<Props, Exports>['loader'];
    render: (loaded: Exports, props: Props & StoreProps & ExtraProps) => React.ReactNode;
    extraProps?: ExtraProps;
}) =>
    Loadable.Map<Props & ExtraProps, Exports>({
        loader,
        render(loaded, props) {
            return <StoreHOC>{(storeProps) => renderFunction(loaded, { ...props, ...storeProps })}</StoreHOC>;
        },
        loading: ({ error, retry }) => (
            <EmptyAsyncContainer
                isFetching
                isLoaderAbsolute
                onTryAgain={retry}
                hasFailed={error}
                errorMessage={<LocalizedText textKey={TextKey.ConnectionErrorMessage} />}
            />
        ),
    });
